import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { CommonService } from 'app/services/common.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import 'chartjs-plugin-datalabels';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';
import * as Chart from 'chart.js';
import { CommonStudentService } from 'app/services/common-student.service';

interface GraphType {
  name?: string;
  value?: number;
}

@Component({
  selector: 'app-parent-careers',
  templateUrl: './parent-careers.component.html',
  styleUrls: ['./parent-careers.component.scss'],
})
export class ParentCareersComponent implements OnInit, OnDestroy {
  careerData = [];
  dataLoaded = false;
  studentUserId: any;
  partnerId: any;
  treeData = [];
  parentChildData: any;
  parentStudentListLoader = false;
  parentStudentId: any;
  getCareersSubscription: Subscription;
  careerDataCount: number;
  getCareerItemsId: number;
  treeItemsData: any;
  treeDatalabel = false;

  selectedCareer: any;
  interestProfiler: any;
  chartDataLabels: any[] = [];
  chartDataValues: any[] = [];
  bar_chart: any;
  options: any;
  education: any[];
  horizontalBarLabels: any[] = [];
  horizontalBarValues: any[] = [];
  horizontalBar_chart: any;
  horizontalBarOptions: any;
  loginUserData;
  Majors = [];
  careerName: string;
  description: string;
  workContents = [];
  toolsAndTechnology = [];
  relatedOccupations = [];
  codeData;
  selectedIndex;
  navigateBack = false;
  hideAssessment;
  isBrightCareer;
  isPinned = false;
  careerId = 0;
  tempNodeData: any;
  routerList: any;
  readMoreCondition = false;
  skills = [];
  tasks = [];
  wagesAndEmployment;
  knowledge = [];
  additionalResouces = [];
  abilities = [];
  careerList: any[];
  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    public _commonRequestResponseService: CommonRequestResponseService,
    public commonDataSharedService: CommonDataSharedService,
    private _commonService: CommonService,
    private draggableModalService: DraggableModalService,
    private _commonDataSharedService: CommonDataSharedService,
    private _commonStudentService: CommonStudentService
  ) {}

  ngOnInit() {
    this.loginUserData = JSON.parse(localStorage.getItem('loginUserData'));
    this.hideAssessment = this.loginUserData.hideAssessment;
    const localStorageData = this._commonAuthService.getLoginData();
    this.studentUserId = localStorageData.userId;
    this.partnerId = localStorageData.partnerId;
    this._commonDataSharedService.reloadStudentCareer.subscribe((data: any) => {
      this.getCareersData();
    })
    this.parentChildData = JSON.parse(
      localStorage.getItem('parentChildLocalData')
    );
    if (this.parentChildData) {
      this.getCareersData();
    }
    this.getCareersSubscription = this.commonDataSharedService.parentHomeData.subscribe(
      (data: any) => {
        this.parentChildData = data;
        this.getCareersData();
      }
    );
  }

  getCareersData() {
    this.parentStudentListLoader = true;
    const selectedType = {
      studentProfileId: this.parentChildData.studentProfileId,
      profileId: this.parentChildData.studentProfileId,
    };

    this._commonRequestResponseService
      .postWithStaticHeaderData('Student/getCareers', selectedType)
      .subscribe(
        (data: any) => {
          const careerListData = [];
          data.clusterItem.forEach(element => element.item.forEach(item => careerListData.push(item)));
          this.careerList = careerListData;
          this.careerData = this.getPinnedCareerData(data.clusterItem);
          this.careerData.sort(
            this._commonService.dynamicSort('-created', false)
          );
          this.careerDataCount = this.careerData.length;
          this.parentStudentListLoader = false;
          this.treeData = data.clusterItem.sort(this._commonService.dynamicSort('name', false));
          this.treeData = this.getSelectedNodeCounter(this.treeData);
          this.getCareerItemsData();
          this.dataLoaded = true;
        },
        () => {
          this.parentStudentListLoader = false;
          this.careerData = [];
          this.notificationService.show(
            'error',
            'Error while fetching career data'
          );
        }
      );
  }

  getSelectedNodeCounter(array) {
    let counter = 0;
    for (let i = 0; i < array.length; i++) {
      counter = 0;
      if (array[i].item && array[i].item.length) {
        for (let j = 0; j < array[i].item.length; j++) {
          if (array[i].item[j].check) {
            counter++;
          }
        }
        array[i].count = counter;
      }
    }
    return array;
  }
  autocompleListFormatter(data: any) {
    return data['name'];
  }
  getPinnedCareerData(careerData: any[]): any[] {
    const pinnedData = [];
    for (let i = 0; i < careerData.length; i++) {
      if (careerData[i].item && careerData[i].item.length) {
        for (let j = 0; j < careerData[i].item.length; j++) {
          if (careerData[i].item[j].check) {
            pinnedData.push(careerData[i].item[j]);
          }
        }
      }
    }

    return pinnedData;
  }
  showCareer(nodeData) {
    this.selectedIndex = '';
    this.studentCareerReadMore(nodeData);
  }


  getCareerItems(item) {
    this.getCareerItemsId = item;
    this.getCareerItemsData();
    this.treeDatalabel = true;
  }

  getCareerItemsData() {
    //this.selectedIndex = '';
    for (let i = 0; i < this.treeData.length; i++) {
      if (this.getCareerItemsId === this.treeData[i].id) {
        this.treeItemsData = this.treeData[i];
      }
    }
  }

  studentCareerReadMore(nodeData) {
    this.tempNodeData = nodeData;
    this.parentStudentListLoader = true;
    const code =
      nodeData.careercode ||
      nodeData.onetSocCode ||
      nodeData.relatedonetsoc_code;
    const name = nodeData.name || nodeData.title;
    const json = {
      OnetSocCode: code.toString(),
      CareerName: name,
      profileId: this.parentChildData.studentProfileId,
    };
    this._commonRequestResponseService
      .postWithHeader('student/getOccupationDetails', json)
      .subscribe(
        (item: any) => {
          this.selectedIndex = 0;

          this.isPinned = item.isPinnedCareer;
          this.careerId = item.careerId;
          this.skills = item.skills;
          this.tasks = item.tasks ? item.tasks : '';
          this.careerName = item.careerName;
          this.description = item.description;
          this.isBrightCareer = item.isBrightCareer;
          this.wagesAndEmployment = item.wagesAndEmployment
            ? item.wagesAndEmployment[0]
            : '';
          this.knowledge = item.knowledge;
          this.additionalResouces = item.additionalResouces;
          this.abilities = item.abilities;

          if (item.interestProfiler && item.interestProfiler.length) {
            this.interestProfiler = item.interestProfiler[0];
          }
          if (item.education && item.education.length) {
            this.education = item.education;
          }
          if (this.interestProfiler) {
            this.buildGraph();
          }
          if (this.education) {
            this.buildHorigontalBar();
          }

          this.Majors = item.careerMajorMapping;
          this.workContents = item.workContent;
          this.toolsAndTechnology = item.toolsAndTechnology;
          this.relatedOccupations = item.relatedOccupations;
          this.readMoreCondition = true;
          this.parentStudentListLoader = false;
        },
        (err) => {
          this.parentStudentListLoader = false;
        }
      );
  }

  buildGraph() {
    this.chartDataLabels = [];
    this.chartDataValues = [];
    for (const key in this.interestProfiler) {
      this.chartDataLabels.push(key.toUpperCase());
      this.chartDataValues.push(this.interestProfiler[key]);
    }
    if (this.chartDataLabels && this.chartDataValues) {
      this.barGraphs(this.chartDataLabels, this.chartDataValues);
    }
  }

  barGraphs(chartDataLabels: any[], chartDataValues: any[]) {
    this.bar_chart = {
      labels: chartDataLabels,
      datasets: [
        {
          backgroundColor: [
            'rgb(218, 96, 137)',
            'rgb(65, 131, 212)',
            'rgb(239, 181, 102)',
            'rgb(108, 223, 162)',
            'rgb(249, 224, 123)',
            'rgb(162, 91, 196)',
          ],
          data: chartDataValues,
          datalabels: {
            borderColor: [
              'rgb(218, 96, 137)',
              'rgb(65, 131, 212)',
              'rgb(239, 181, 102)',
              'rgb(108, 223, 162)',
              'rgb(249, 224, 123)',
              'rgb(162, 91, 196)',
            ],
            borderWidth: 2,
          },
        },
      ],
    };
    this.options = {
      responsive: true,
      title: {
        display: false,
      },
      legend: {
        position: 'bottom',
        display: false,
      },
      scales: {
        xAxes: [
          {
            barPercentage: 0.7,
            categoryPercentage: 1.0,
            ticks: {
              beginAtZero: true,
              fontColor: '#000',
              fontSize: window.innerWidth > 767 ? 10 : 8,
              padding: 14,
              fontStyle: 'bold',
              fontFamily: `Asul', 'Georgia', 'Times New Roman', serif`,
            },
            gridLines: {
              display: false,
              lineWidth: 0,
              zeroLineBorderDash: [10, 5],
              zeroLineBorderDashOffset: 8,
              zeroLineWidth: 2,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              color: '#000',
              max: window.innerWidth > 767 ? 112 : 130,
              beginAtZero: true,
              fontSize: 15,
              stepSize: 1,
              display: false,
            },
            gridLines: {
              display: false,
              lineWidth: 0,
              zeroLineBorderDash: [10, 5],
              zeroLineBorderDashOffset: 0.8,
              zeroLineWidth: 2,
            },
          },
        ],
      },
      plugins: {
        datalabels: {
          formatter: (value, ctx) => {
            let percentage;
            if (value === 100) {
              percentage = value + '%';
            } else if (value < 10) {
              percentage = ' ' + ' ' + value + '% ' + ' ';
            } else if (value > 9 && value < 20) {
              percentage = ' ' + value + '% ' + ' ';
            } else if (value < 50 && value > 19) {
              percentage = ' ' + value + '%' + ' ';
            } else {
              percentage = ' ' + value + '%' + ' ';
            }

            return percentage;
          },
          anchor: 'end',
          backgroundColor: '#fff',
          color: '#707071',
          borderRadius: 100,
          font: {
            size: 12,
            family: `Asul', 'Georgia', 'Times New Roman, serif`,
            weight: '400',
          },
          padding: {
            top: window.innerWidth > 767 ? 15 : 8,
            bottom: window.innerWidth > 767 ? 15 : 8,
            left: window.innerWidth > 767 ? 8 : 1,
            right: window.innerWidth > 767 ? 8 : 1,
          },
        },
      },
    };
  }

  buildHorigontalBar() {
    const masterSdegree: GraphType = {};
    const bachelorSdegree: GraphType = {};
    const associateSdegree: GraphType = {};
    const postSecondaryCertificate: GraphType = {};
    const professionalDegree: GraphType = {};
    const doctoralDegree: GraphType = {};

    this.education.forEach((data) => {
      const name = data.category_description.toLowerCase();
      switch (name) {
        case 'bachelors degree':
          bachelorSdegree.name = `BACHELOR'S DEGREE`;
          bachelorSdegree.value = +data.percentageofRespondents;
          break;
        case 'masters':
          masterSdegree.name = 'MASTERS';
          masterSdegree.value = +data.percentageofRespondents;
          break;

        case 'associates degree':
          associateSdegree.name = `ASSOCIATE'S DEGREE`;
          associateSdegree.value = +data.percentageofRespondents;
          break;
        case 'post-secondary certificate':
          postSecondaryCertificate.name = 'POST-SECONDARY CERTIFICATE';
          postSecondaryCertificate.value = +data.percentageofRespondents;
          break;
        case 'professional degree':
          professionalDegree.name = 'PROFESSIONAL DEGREE';
          professionalDegree.value = +data.percentageofRespondents;
          break;
        case 'doctoral degree':
          doctoralDegree.name = 'DOCTORAL DEGREE';
          doctoralDegree.value = +data.percentageofRespondents;
          break;
      }
    });
    this.horizontalBarLabels = [];
    this.horizontalBarValues = [];
    if (Object.keys(associateSdegree).length) {
      this.horizontalBarLabels.push(associateSdegree.name);
      this.horizontalBarValues.push(associateSdegree.value);
    }
    if (Object.keys(postSecondaryCertificate).length) {
      this.horizontalBarLabels.push(postSecondaryCertificate.name);
      this.horizontalBarValues.push(postSecondaryCertificate.value);
    }
    if (Object.keys(bachelorSdegree).length) {
      this.horizontalBarLabels.push(bachelorSdegree.name);
      this.horizontalBarValues.push(bachelorSdegree.value);
    }
    if (Object.keys(masterSdegree).length) {
      this.horizontalBarLabels.push(masterSdegree.name);
      this.horizontalBarValues.push(masterSdegree.value);
    }
    if (Object.keys(professionalDegree).length) {
      this.horizontalBarLabels.push(professionalDegree.name);
      this.horizontalBarValues.push(professionalDegree.value);
    }
    if (Object.keys(doctoralDegree).length) {
      this.horizontalBarLabels.push(doctoralDegree.name);
      this.horizontalBarValues.push(doctoralDegree.value);
    }
    if (this.horizontalBarLabels && this.horizontalBarValues) {
      this.horigontalBar(this.horizontalBarLabels, this.horizontalBarValues);
    }
  }

  horigontalBar(chartDataLabels: any[], chartDataValues: any[]) {
    this.horizontalBar_chart = {
      labels: chartDataLabels,
      datasets: [
        {
          backgroundColor: [
            'rgb(249, 224, 123)',
            'rgb(108, 223, 162)',
            'rgb(239, 181, 102)',
            'rgb(65, 131, 212)',
            'rgb(218, 96, 137)',
            'rgb(162, 91, 196)',
          ],
          data: chartDataValues,
          datalabels: {
            borderColor: [
              'rgb(249, 224, 123)',
              'rgb(108, 223, 162)',
              'rgb(239, 181, 102)',
              'rgb(65, 131, 212)',
              'rgb(218, 96, 137)',
              'rgb(162, 91, 196)',
            ],
            borderWidth: 1,
          },
        },
      ],
    };
    this.horizontalBarOptions = {
      title: {
        display: false,
      },
      legend: {
        position: 'bottom',
        display: false,
      },
      scales: {
        xAxes: [
          {
            // position: 'bottom',
            ticks: {
              beginAtZero: true,
              display: false,
              max: 110,
            },
            gridLines: {
              display: false,
              lineWidth: 0,
              zeroLineBorderDash: [10, 5],
              zeroLineBorderDashOffset: 8,
              zeroLineWidth: 2,
            },
          },
        ],
        yAxes: [
          {
            barPercentage: 1.0,
            categoryPercentage: 0.8,
            ticks: {
              color: '#000',
              beginAtZero: true,
              // fontSize: 10,
              stepSize: 5,
              mirror: true,
              // padding: -6,
              display: false,
              labelOffset: 20,
            },
            gridLines: {
              display: false,
              lineWidth: 0,
              zeroLineBorderDash: [10, 5],
              zeroLineBorderDashOffset: 0.8,
              zeroLineWidth: 2,
            },
          },
        ],
      },
      animation: {
        onComplete() {
          const chartInstance = this.chart;
          const ctx = chartInstance.ctx;
          const dataset = this.data.datasets[0];
          const meta = chartInstance.controller.getDatasetMeta(0);

          Chart.helpers.each(
            meta.data.forEach((bar, index) => {
              const label = this.data.labels[index];
              const labelPositionX = 20;
              const labelWidth = ctx.measureText(label).width + labelPositionX;

              ctx.font = Chart.helpers.fontString(
                Chart.defaults.global.defaultFontSize,
                'normal',
                Chart.defaults.global.defaultFontFamily
              );
              ctx.textBaseline = 'middle';
              ctx.textAlign = 'left';
              ctx.labelsize = 9;
              ctx.font = `12px 'Asul', 'Georgia', 'Times New Roman', serif`;
              ctx.fillStyle = '#000';
              if (this.data.datasets[0].data[index] >= 50) {
                ctx.fillText(label, labelPositionX, bar._model.y);
              } else {
                ctx.fillText(label, bar._model.x + 15, bar._model.y);
              }
            })
          );
        },
      },
      plugins: {
        datalabels: {
          formatter: (value, ctx) => {
            const percentage = value + '%';
            return percentage;
          },
          anchor: 'end',
          align: 'center',
          backgroundColor: '#fff',
          color: '#000',
          borderRadius: 25,
          font: {
            size: 10,
            family: `Asul', 'Georgia', 'Times New Roman', serif`,
            lineHeight: 2,
          },
          padding: {
            top: 2,
            bottom: 2,
            left: 2,
            right: 2,
          },
          display: true,
        },
      },
    };
  }
  readMoreGraph() {
    const baseId = 'modal-coachinghub-article';
    this.draggableModalService.show({
      baseId,
      id: 'readMoreGraph',
      trayTitle: 'Interests for this Career',
      initialState: {
        title: 'Interests for this Career',
        content: `<h4 class='modal-career-title'>Realistic</h4>
      <div class='interests-icon-paragraph'>
      <ul>
          <li>Tend to be down-to-earth and practical, straightforward/frank, mechanically inclined, reserved,
              stable, concrete, independent, ambitious, systematic</li>
          <li>Like working outdoors, being physically active, using their hands, building things, tending/training
              animals, and/or working on electronic equipment</li>
          <li>Prefer occupations that involve building or repairing things</li>
      </ul>
  </div>
  <h4 class='modal-career-title'>Investigative</h4>
  <div class='interests-icon-paragraph'>
  <ul>
      <li>Tend to be inquisitive, analytical, scientific, observant/precise, scholarly, cautious,
          intellectually self-confident, independent, logical, complex, curious, studious</li>
      <li>Likes to think abstractly, solve math problems, understand scientific theories, do complex
          calculations, use a microscope or computer, interpret formulas</li>
      <li>Prefers occupations in scientific and medical fields</li>
  </ul>
</div>
<h4 class='modal-career-title'>Artistic</h4>
<div class='interests-icon-paragraph'>
            <ul>
                <li>Tend to be creative, imaginative, innovative, unconventional, emotional, independent, expressive,
                    original, introspective, impulsive, sensitive, courageous, complicated, idealistic, nonconforming,
                    free-thinking</li>
                <li>Like to sketch, draw, paint, play a musical instrument, write stories, poetry, and/or music, sing,
                    act, dance, design fashions or interiors, attend concerts, theatre, art exhibits, work on crafts,
                    take photography, express themselves creatively, deal with ambiguous ideas</li>
                <li>Prefers occupations using creative talents</li>
            </ul>
        </div>
        <h4 class='modal-career-title'>Social</h4>
        <div class='interests-icon-paragraph'>
            <ul>
                <li>Tend to be friendly, helpful, idealistic, insightful, outgoing, understanding, cooperative, generous, responsible, forgiving, patient, kind</li>
                <li>Likes to work in groups, help people with problems, do volunteer work, work with young people, serve others teach/train others, express yourself clearly, lead a group discussion, mediate disputes, plan and supervise an activity, cooperate with others</li>
                <li>Prefers occupations such as teaching, nursing, and counseling</li>
            </ul>
        </div>
        <h4 class='modal-career-title'>Enterprising</h4>
        <div class='interests-icon-paragraph'>
            <ul>
                <li>Tend to be self-confident, assertive, persuasive, energetic, adventurous, popular, ambitious, agreeable, talkative, extroverted, spontaneous, optimistic</li>
                <li>Like to make decisions, be elected to office, start their own business, campaign politically, meet important people, have power or status, initiate projects, convince people to do things your way, sell things, give talks or speeches, organize activities, lead or manage a group, persuade others</li>
                <li>Prefers occupations involving sales or management of people or things</li>
            </ul>
        </div>
        <h4 class='modal-career-title'>Conventional</h4>
        <div class='interests-icon-paragraph'>
            <ul>
                <li>Tend to be well-organized, accurate, numerically inclined, responsible, methodical, conscientious, efficient, conforming, dependable, detail-oriented, practical, thrifty, systematic, structured, polite, ambitious, obedient, persistent</li>
                <li>Like to do paperwork, work within a system, keep accurate records, write business letters, work at a computer, follow clearly defined procedures, use data-processing equipment, work with numbers, type or take shorthand, be responsible for details, collect or organize things</li>
                <li>prefers occupations involving record-keeping, computation, typing, or computer operation</li>
            </ul>
        </div>
  `,
      },
    });
  }
  relatedCareers(code) {
    window.scroll(0, 230);
    this.studentCareerReadMore(code);
  }
  categories() {
    this.treeDatalabel = false;
    this.tempNodeData = '';
  }
  backToCategories() {
    this.readMoreCondition = false;
  }
  pinToMyCareers() {
    if (this.isPinned) {
      this.unPinCareer(this.careerId);
      this.isPinned = !this.isPinned;
    } else {
      this.pinCareer(this.careerId);
      this.isPinned = !this.isPinned;
    }
  }

  pinCareer(id) {
    const inputJson = {
      studentProfileID: this.parentChildData.studentProfileId,
      partnerId: this.partnerId,
      profileId: this.parentChildData.studentProfileId,
      careerClassId: id,
      coachComment: '',
      myComment: ''
    };
    this.parentStudentListLoader = true;
    this._commonRequestResponseService.postWithHeader('student/pinCareers ', inputJson, ['partnerId'])
      .subscribe(
        () => {
          this.parentStudentListLoader = false;
          this.notificationService.show('success', 'Career pinned successfully');
          this.selectedCareer = null;
          this._commonStudentService.getCompletedDate();
          this._commonDataSharedService.reloadStudentCareer.next();
        },
        () => {
          this.parentStudentListLoader = false;
          this.notificationService.show('error', 'Error while pining data');
        }
      );

  }
  unPinCareer(id) {
        this.notificationService.show('error', `Career Can't be remove`);
  }
  showCareersCondition(nodeData) {
    this.parentStudentId = JSON.parse(localStorage.getItem('parentStudentId'));
    if (nodeData && nodeData.careercode) {
      const inputJson = {
        careercode: nodeData.careercode.toString(),
        StudentUserId: this.parentStudentId
      };

      this._commonRequestResponseService.postWithHeader('shared/yousciencecareer ', inputJson)
        .subscribe(
          (data: any) => {
            if (data.url) {
              const newWin = window.open(data.url, '_blank');
              if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
                alert('Please disable your pop-up blocker and click the open link again')
              }
            }
          },
          () => {
            this.notificationService.show('error', 'Error while getting career data');
          });
    }
  }

  studentCareer(nodeData) {

    if (nodeData && nodeData.careercode) {
      const inputJson = {
        careercode: nodeData.careercode.toString(),
        StudentUserId: this.parentChildData.studentProfileId
      };
      this._commonRequestResponseService.postWithHeader('shared/yousciencecareer ', inputJson)
        .subscribe(
          (data: any) => {
            if (data.url) {
              const newWin = window.open(data.url, '_blank');

              if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
                alert('Please disable your pop-up blocker and click the open link again')
              }

            }
          },
          () => {
            this.notificationService.show('error', 'Error while getting career data');
          }
        );
    }
  }
  onTabSelect(event: number) {
    // if (event === 1) {
    //   const loginData = this._commonAuthService.getLoginData();
    //   if (this._loginInfoProvider.roleName.toLowerCase() !== 'student') {
    //     this.studentUserId = localStorage.getItem('studentLocalId')
    //   }
    //   const inputJson = {
    //     createdBy: loginData.userId,
    //     studentUserId: this.studentUserId
    //   };

    //   this._commonRequestResponseService.postWithHeader('shared/youscience/viewedsavedcareers', inputJson)
    //     .subscribe(
    //       () => {
    //         // ???
    //         this.getCareersData();
    //       },
    //       () => {
    //         this.notificationService.show('error', 'Error while fetching data');
    //       });
    // } else if (event === 0 && this.tempNodeData) {
    //   //this.studentCareerReadMore(this.tempNodeData)
    // }
  }

  ngOnDestroy() {
    this.getCareersSubscription.unsubscribe();
  }
}
